<template>
  <el-tabs type="border-card">
    <my-power-station-one :beg="beg" />
  </el-tabs>
</template>

<script>
import MyPowerStationOne from "./MyPowerStationOne";

export default {
  name: "PowerStationMain",
  components: {
    MyPowerStationOne,
  },
  data() {
    return {
      beg: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "设备详细") {
      //如果是设备详细跳转过来的，通知页面
      sessionStorage.setItem("fromDetailParams", "true");
    }
    next();
  },
};
</script>
